import React, { useState, useEffect } from "react"
import Container from "../Container"

import Button from "../Button"
import NavLink from "./NavLink"
import SubMenuNav from "./SubMenuNav"
import { Link, navigate } from "gatsby"
import { motion, useScroll } from "framer-motion"
import main_logo from "../../images/main_logo.svg"
import menu_icon from "../../images/menu_icon.svg"
import close_icon from "../../images/close_icon.svg"
import location_logo from "../../images/footer/location_logo.svg"
import phone_logo from "../../images/footer/phone_logo.svg"
import instagram_logo from "../../images/footer/instagram_logo.svg"
import facebook_logo from "../../images/footer/facebook_logo.svg"
import twitter_logo from "../../images/footer/twitter_logo.svg"
import linkedin_logo from "../../images/footer/linkedin_logo.svg"
import { useLocation } from "@reach/router"

export const links = [
  {
    text: "ABOUT",
    url: "/about/",
  },
  {
    text: "SERVICES",
    url: "/services/",
  },
  {
    text: "WORK",
    url: "/works/",
  },
]

function Navbar() {
  const [openMenu, setOpenMenu] = useState(false)

  const [hidden, setHidden] = useState(false)
  const location = useLocation()
  console.log(location.pathname)

  const { scrollY } = useScroll()
  function update() {
    if (scrollY?.current < scrollY?.prev || scrollY?.current < 200) {
      setHidden(false)
    } else if (scrollY?.current > 100 && scrollY?.current > scrollY?.prev) {
      setHidden(true)
    }
  }

  useEffect(() => {
    return scrollY.onChange(() => update())
  }, [])

  const variants = {
    /** this is the "visible" key and it's correlating styles **/
    visible: { opacity: 1, y: 0 },
    /** this is the "hidden" key and it's correlating styles **/
    hidden: { opacity: 0, y: -25 },
  }

  return (
    <motion.div
      className={`fixed top-0 left-0 bg-white right-0 z-[10000] w-full `}
      variants={variants}
      /** it's right here that we match our boolean state with these variant keys **/
      animate={hidden ? "hidden" : "visible"}
      initial={"visible"}
      /** I'm also going to add a custom easing curve and duration for the animation **/
      transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.6 }}
    >
      <Container>
        <div className=" bg-transparent flex items-center justify-between gap-6 py-4">
          <div
            className="block md:hidden cursor-pointer"
            onClick={() => {
              setOpenMenu(true)
            }}
          >
            <img src={menu_icon} alt="" />
          </div>
          <div className="hidden text-[12px] md:flex gap-[19px]">
            {links.map(link => (
              <Link
                className={`px-4 py-2 border border-1 rounded-[5px] border-[#C6C6C6] ${
                  location.pathname === link.url && "text-[#FF8616]"
                }`}
                href={link.url}
              >
                {link.text}
              </Link>
            ))}
          </div>
          <Link href="/" className="mx-auto w-[144px]">
            <img className="w-full" src={main_logo} alt="" />
          </Link>
          <div className=" hidden md:flex gap-[16px]">
            <Button
              text="CONTACT US"
              onClick={() => navigate("/contactus")}
              variant="outline"
            />
            <Button text="GET A QUOTE" variant="filled" />
          </div>
        </div>
      </Container>
      <div
        className={` fixed overflow-scroll md:hidden top-0 left-0 w-full h-screen bg-white transition-all ease-in duration-300 ${
          openMenu ? "translate-x-0" : "translate-x-[100%]"
        } `}
      >
        <div className="relative ">
          <div
            className="absolute left-4 top-4 cursor-pointer"
            onClick={() => setOpenMenu(false)}
          >
            <img src={close_icon} alt="" />
          </div>
          <div className=" gap-8  pt-36 px-5 flex flex-col">
            {links.map(link => (
              <SubMenuNav key={link.url} link={link} />
            ))}
            {/* <div className="w-[300px] ">
              <Button color="#fff" onClick={() => navigate("/contactus")}>
                Talk to sales
              </Button>
            </div> */}
            <div className=" flex flex-col gap-[16px] w-[150px] ">
              <Button
                text="CONTACT US"
                onClick={() => navigate("/contactus")}
                variant="outline"
              />
              <Button text="GET A QUOTE" variant="filled" />
            </div>
          </div>
          <hr className="mb-[26px] mx-5 border-t opacity-[0.2] mt-[80px] border-[#8B8B8B]" />
          <div className="text-[#000000] px-5">
            <div className="flex gap-4 items-center mb-4">
              <img className="w-[25px]" src={location_logo} alt="" />

              <p className="text-[14px] font-[400]">
                ABC Company, 123 East, 17th Street, St. louis 10001
              </p>
            </div>
            <div className="flex gap-4 mb-6 items-center">
              <img className="w-[25px]" src={phone_logo} alt="" />

              <p className="text-[14px] font-[400]">07956223569 </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 items-start lg:items-center">
              <p className="opacity-50 font-[500]">Social Media</p>

              <div className="flex items-center gap-6">
                <img src={facebook_logo} alt="" />
                <img src={twitter_logo} alt="" />
                <img src={linkedin_logo} alt="" />
                <img src={instagram_logo} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Navbar
